import type { LocalAddressBarangay } from '../hooks/useLocalAddressesBarangays';

/**
 * Utility function to get zip code from selected barangay
 * @param barangays - Array of barangay objects from useLocalAddressesBarangays hook
 * @param selectedBarangay - The selected barangay description string
 * @returns The zip code string if found, empty string if not found
 */
export const getZipCodeFromBarangay = (
  barangays: LocalAddressBarangay[],
  selectedBarangay: string
): string => {
  if (!barangays || barangays.length === 0 || !selectedBarangay) {
    return '';
  }

  const matchingBarangay = barangays.find(
    barangay => barangay.barangayDescription === selectedBarangay
  );

  return matchingBarangay?.zipCode || '';
};

/**
 * Utility function to check if a zip code should be auto-populated
 * @param selectedBarangay - The selected barangay description string
 * @param barangays - Array of barangay objects
 * @returns Boolean indicating if zip code should be auto-populated
 */
export const shouldAutoPopulateZipCode = (
  selectedBarangay: string,
  barangays: LocalAddressBarangay[]
): boolean => {
  return !!(selectedBarangay && barangays && barangays.length > 0);
};